import {cn} from '@/lib/utils'

type HorizontalRuleSpacing = 'none' | 'sm' | 'md' | 'lg'

interface HorizontalRuleProps {
    spacing?: HorizontalRuleSpacing
    className?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const spacingClasses: Record<HorizontalRuleSpacing, string> = {
    none: '',
    sm: 'my-2',
    md: 'my-4',
    lg: 'my-6',
}
/* eslint-enable i18next/no-literal-string */

/**
 * Plain visual divider rendered as a top border. Use {@link SectionDivider}
 * when you need a titled separator with inline content.
 */
export function HorizontalRule({spacing = 'md', className}: HorizontalRuleProps) {
    return <div className={cn('border-t', spacingClasses[spacing], className)}/>
}
